<form [formGroup]="form" [patchForm]="selectedFilters$ | async">
  <h4 class="" [hidden]="filterIsSelected$ | async">
    {{ 'general.selectAFilter' | translate }}
  </h4>

  <div class="row gx-2">
    <div class="col-md-6 mb-3">
      <label class="form-label">
        {{ 'bookingModule.selectResource' | translate }}
      </label>
      <product-select-input-multiple
        [products]="bookableProducts$ | async"
        formControlName="selectedBookableProductIds"
        [allowClearing]="true"
        (search)="onSearchProducts($event)"
        [dataTestId]="'booking-bookable-multiple-select'"
      ></product-select-input-multiple>
    </div>
    <div class="col-md-6 mb-3">
      <label class="form-label">
        {{ 'bookingModule.selectResourceGroup' | translate }}
      </label>
      <product-select-input-multiple
        (search)="onSearchProductGroups($event)"
        [products]="productGroups$ | async"
        formControlName="selectedProductGroupIds"
        [allowClearing]="true"
        [dataTestId]="'booking-locations-multiple-select'"
      ></product-select-input-multiple>
    </div>
  </div>
  <day-selector
    class="mb-4"
    [startDate]="defaultStarDay"
    [stickyToday]="false"
    [maxNumberOfDaysToShow]="7"
    (onDaySelected)="onDaySelected($event)"
  >
  </day-selector>

  <serie-proposal-item-schedule
    [bookableSlots$]="bookableSlotsAndSerieProposalItems$"
    [latestBookableSlots$]="latestBookableSlots$"
    [targetedProductsIds]="targetedProductsIds$ | async"
    [config]="scheduleConfig$ | async"
    (onClickBookableSlot)="onClickEvent($event)"
    (onClickSerieProposalItem)="onSerieProposalItemClick($event)"
  >
  </serie-proposal-item-schedule>

  <div class="mt-2">
    <span class="legend-indicator bg-primary"></span> Existing booking
    <span class="legend-indicator bg-success ms-3"></span> Proposal (possible)
    <span class="legend-indicator bg-danger ms-3"></span> Proposal conflict
  </div>
</form>
